import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, NavLink, useNavigate } from "react-router-dom";
// import image from "../assets/home/markersection2.png";
import image from "../assets/home/4.png";
import Header from "../components/header";
import SidebarHeader from "../components/sidebarHeader";
import { useMediaQuery } from "react-responsive";
import resume1 from "../assets/resume/resume1.png";
import resume3 from "../assets/resume/resume2.png";
import resume4 from "../assets/resume/resume3.png";
import resume5 from "../assets/resume/resume4.png";
import resume6 from "../assets/resume/resume5.png";
import resume7 from "../assets/resume/resume6.png";
import resume8 from "../assets/resume/resume7.png";
import resume9 from "../assets/resume/resume8.png";
import resume10 from "../assets/resume/resume9.png";
import resume11 from "../assets/resume/resume10.png";
import resume12 from "../assets/resume/resume11.png";
import resume13 from "../assets/resume/resume12.png";
import resume14 from "../assets/resume/resume13.png";
import PricingCard from "../components/PricingCard";
// import card1 from "../assets/home/maker4uuu.png";
import card1 from "../assets/home/Intuitive Design.webp";
import card7 from "../assets/home/SEAMLESS ANALYTICS INTEGRATION.webp";

import Footer from "../components/Footer";
import "./styles.css";
import Faq from "../components/Faq";
import Main from "../components/home/English/Main";
// import Main from "../components/home/Arabic/Main";
import Feature from "../components/home/English/feature";
import FeatureA from "../components/home/Arabic/featureA";
import FeatureTwo from "../components/home/English/FeatureTwo";
import axios from "axios";
import { useSelector } from "react-redux";
import FeatureTwoA from "../components/home/Arabic/FeatureTwoA";
// import markersection from "../assets/home/markersection.png";
import markersection from "../assets/home/color and text.webp";
// import ghq4 from "../assets/home/ghq4.png";
import ghq4 from "../assets/home/Design.webp";
import MainA from "../components/home/Arabic/MainA";
import {  useDispatch } from "react-redux";
import { loginUser } from "../Redux/authAction";
import apiConfig from '../config/api.js';

const Home = () => {
  const [menu, setMenu] = useState("");
  const handleMouseOver = (type) => {
    setMenu(type);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [pack, setPack] = useState(false);
  const [data, setData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState("");
  const [packages, setPackages] = useState([]);
  const [packageError, setPackageError] = useState("");

  const isLang = useSelector((state) => state.authReducer.lang);
  const isSignin = useSelector((state) => state.authReducer.issign);
  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const userID = useSelector((state) => state.authReducer.uid);

  const displayName = useSelector((state) => state.authReducer.displayName);
  const email = useSelector((state) => state.authReducer.email);
  const uid = useSelector((state) => state.authReducer.uid);
  const packageId = useSelector((state) => state.authReducer.packageId);
  const status = useSelector((state) => state.authReducer.status);
  const temp_pkgid = useSelector((state) => state.authReducer.temp_pkgid);
  const temp_id = useSelector((state) => state.authReducer.temp_id);
 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${apiConfig.API_URL}/aapi/getcategories.php`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        setError("Error fetching categories: " + error.message);
      }
    };

    fetchData();
  }, []);

  const subscription = async () => {
    try {
      if (isAuthenticated) {
        const formData = new FormData();
        formData.append("uid", userID);
        console.log("Get subcription data is going to call......");
  
        const response = await fetch(`${apiConfig.API_URL}/aapi/getsubscriptiondata.php`, {
          method: "POST",
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error("Failed to fetch subscription data.");
        }
  
        const data = await response.json();
        console.log("data fetched:",data);
    
        if (data.status === "success" && data.data.length > 0) {
          const subscription = data.data[0]; // Get the first subscription record
          const { packageid, status } = subscription;
          console.log("package id",packageid,"status",status);
  
          dispatch(loginUser({ displayName, email, uid, packageid, status,temp_pkgid, temp_id })); // Fix: Using 'email' here
          console.log("------!!---!!--MY data to store in redux is:",  displayName, email, uid, packageid, status,temp_pkgid, temp_id );
          console.log("Response:", data);
        } else {
          console.log("No data received from the API.");
        }
      } else {
        console.log("User is not authenticated.");
      }
    } catch (error) {
      // Log error in case of failure
      console.error("Error occurred during subscription:", error);
    }
  };
  

  useEffect(() => {
    const fetchPackageData = async () => {
      try {
        const response = await fetch(`${apiConfig.API_URL}/aapi/getPackages.php`);
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();
        setPackages(data);
      } catch (error) {
        setPackageError("Error fetching categories: " + error.message);
      }
    };

    subscription();
    fetchPackageData();
  }, []);

  if (isAuthenticated) {
    const api_url = `${apiConfig.API_URL}/aapi/getsubscription.php`;

    console.log("----------User id is::",userID);
    // Assuming you need to send some data along with the POST request
    const requestData = {
      user_id: userID,
      package_id: "1",
      duration: "5 Month",
      amount: "999",
      status: "on",
    };

    axios
      .post(api_url, requestData)
      .then((response) => {
        console.log("Response-- of user:", response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

  } else {
    const api_url = `${apiConfig.API_URL}/aapi/getsubscription.php`;

    // Assuming you need to send some data along with the POST request
    const requestData = {
      user_id: userID,
      package_id: "1",
      duration: "5 Month",
      amount: "999",
      status: "on",
    };

    axios
      .post(api_url, requestData)
      .then((response) => {
        console.log("Response:", response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  console.log("package", packages);
  console.log("package", packages[0]?.title);
  console.log("categories", categories);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 3000, min: 1100 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 1100, min: 830 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 830, min: 650 },
      items: 3,
    },
    mdtablet: {
      breakpoint: { max: 650, min: 400 },
      items: 2,
    },

    mobile: {
      breakpoint: { max: 400, min: 0 },
      items: 1,
    },
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1220px)",
  });

  const isDesktop = useMediaQuery({
    query: "(min-width: 1200px)",
  });
  const isTablet = useMediaQuery({
    query: "(min-width: 900px)",
  });
  const isMobile = useMediaQuery({
    query: "(min-width: 600px)",
  });

  const isCarsial = useMediaQuery({
    query: "(max-width: 400px)",
  });

  return (
    <div>
      <div>
        {isDesktopOrLaptop ? (
          <Header menu={menu} setMenu={setMenu} />
        ) : (
          <SidebarHeader />
        )}
      </div>

      <div style={{ paddingTop: "80px" }}>
        <div style={{ maxWidth: "1400px", margin: "auto" }}>
        {/* {isLang !== "arabic" ? <><h1>English</h1></> : <><h1>Arabic</h1></>} */}
           {isLang !== "arabic" ? <Main /> : <MainA />} 
          {/* <Main /> */}
        </div>

        <section style={{ maxWidth: "1400px", margin: "auto" }}>
          <div className="mt-[20px]  mb-5 text-[#262b33] px-4">
            {isLang !== "arabic" ? (
              <p className="text-center font-[600] md:text-[28px] text-[25px] ">
                What are you looking for today ?
              </p>
            ) : (
              <p className="text-center text-3xl font-bold ">
                مناسبا تماما للجميع
              </p>
            )}
            <div className="flex justify-center mt-[25px]  ">
              {isLang !== "arabic" ? (
                <p
                  style={{
                    width: "clamp(300px,100%, 800px)",
                    textAlign: "center",
                    color: "#2b2b2b",
                    fontFamily:"poppins",
                    fontSize:"18px"
                  }}
                >
                  Create content, brand assets, social media posts, graphics, banners, and more in minutes with the help of hundreds of lovely templates.
                </p>
              ) : (
                <p
                  style={{
                    width: "clamp(300px,100%, 800px)",
                    textAlign: "center",
                    fontSize: "16px",
                  }}
                >
                  ارفع مستوى تسويقك دون ضغوط مالية. يقدم Maker4U خطط تسعير مرنة
                  قابلة للتعديل لتناسب الشركات بجميع أحجامها. اختر الخطة التي
                  تتوافق مع طموحاتك وشاهد عروضك الترويجية تصل إلى آفاق جديدة.
                </p>
              )}
            </div>
          </div>
          <div className={` w-[94%] m-auto`}>
            <Carousel
              autoPlay={true}
              infinite={true}
              responsive={responsive}
              transitionDuration={500}
            >
              {categories.map((category, index) => (
                <div
                  className="relative group w-full"
                  key={index}
                  style={{ padding: "30px 0" }}
                >
                  {
                    <LazyLoadImage
                      src={`aapi/${category.imagepath}`}
                      alt={category.title}
                      className="hidden"
                      onLoad={() => {}}
                      onError={() => {}}
                    />

                    // <LazyLoadImage
                    // src={`https://api.maker4u.com/${category.imagepath}`}
                    // height={180}
                    // width={200}
                    // alt={category.title}
                    // />
                  }

                  <NavLink
                    // to={`/category/${category.title}`}
                    to={`/resumeMaker/temp/${category.title}`}
                    className="hover:no-underline"
                  >
                    <div
                      className={`${
                        isCarsial
                          ? "w-[calc(100%-14px)] m-auto"
                          : "w-[calc(100%-10px)]"
                      } ${
                        isLang !== "arabic" ? "text-left text-[22px]" : ""
                      } h-full block rounded-[22px] p-3 text-[#282828] border`}
                    >
                      {/* Use the fetched image directly in the src attribute */}
                      <LazyLoadImage
                        className="w-full h-[160px] rounded-t-[6px] object-cover"
                        src={`aapi/${category.imagepath}`}
                        alt={category.title}
                      />
                      <p className="text-[17px] text-[#262b33] font-[600] mt-5 ">
                        {category.title}
                      </p>
                      <p className="leading-4 mb-5 text-[12px] text-[#2b2b2b]">
                        {category.description}
                      </p>
                    </div>
                  </NavLink>
                </div>
              ))}
            </Carousel>
          </div>
        </section>

      {/* Pricing Card */}
      <section style={{ maxWidth: "1400px", margin: "auto" }}>
          <div className="mt-[60px]  text-[#262b33]">
            {
              <p className="text-center font-[600] text-[28px] ">
                A perfect fit for everyone
              </p>
           }
            <div className="flex justify-center mt-[25px]  ">
              {isLang !== "arabic" ? (
                <p
                  style={{
                    width: "clamp(300px,100%, 800px)",
                    textAlign: "center",
                    color: "#2b2b2b",
                  }}
                >
                  Elevate your marketing without financial stress. Maker4U
                  offers flexible pricing plans adjustable to businesses of all
                  sizes. Choose the plan that aligns with your ambitions and
                  witness your promotions mount to new heights.
                </p>
              ) : (
                <p
                  style={{
                    width: "clamp(300px,100%, 800px)",
                    textAlign: "center",
                    fontSize: "16px",
                  }}
                >
                  ارفع مستوى تسويقك دون ضغوط مالية. يقدم Maker4U خطط تسعير مرنة
                  قابلة للتعديل لتناسب الشركات بجميع أحجامها. اختر الخطة التي
                  تتوافق مع طموحاتك وشاهد عروضك الترويجية تصل إلى آفاق جديدة.
                </p>
              )}
            </div>
          </div>
          <div className="border-[1px] w-[320px] flex h-[60px] rounded-[12px] shadow-md p-[6px] mt-14 mb-10 م-auto ">
            <div
              style={{
                background:
                  pack === false
                    ? "#9333EA"
                    : "",
                color: pack === false ? "white" : "black",
              }}
              className={`  ${
                isLang === "eng" ? "" : "text-[22px] font-[600]"
              } w-[50%]  flex justify-center items-center rounded-md cursor-pointer`}
              onClick={() => setPack(false)}
            >
              {isLang !== "arabic" ? "Monthly" : "شهريا"}
            </div>
            <div
              style={{
                background: pack
                  ? "#9333EA"
                  : "",
                color: pack ? "white" : "black",
              }}
              className={`  ${
                isLang === "eng" ? "" : "text-[22px] font-[600]"
              } w-[50%]  flex justify-center items-center rounded-md cursor-pointer`}
              onClick={() => setPack(true)}
            >
              {isLang !== "arabic" ? "Yearly" : "سنوي"}
            </div>
          </div>
          <div className="flex justify-center gap-[15px] flex-wrap border-[rgba(57,76,96,.15)]">
  {pack === false ? (
    <>
      <PricingCard
        color={"#dedede"}
        hoverColor={"#f4f2f5"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[0]?.title}` : "حر"}
        desc={isLang !== "arabic" ? `${packages[0]?.title} Package` : "حزمة مجانية"}
        price={`${packages[0]?.price}`}
        packageId={"1"}
        duration="month"
        features={
          isLang !== "arabic"
            ? ["Free Templates"]
            : ["قوالب مجانية"] // Features in Arabic
        } // Pass features as props
      />
      <PricingCard
        color={"HSLA(0,100%,66%,1)"}
        hoverColor={"#fc4444"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[1]?.title}` : "عمل"}
        desc={isLang !== "arabic" ? `${packages[1]?.title} Plan` : "خطة عمل"}
        price={`${packages[1]?.price}`}
        packageId={"2"}
        duration="month"
        features={
          isLang !== "arabic"
            ? ["Free Templates", "Business Templates"]
            : ["قوالب مجانية", "قوالب الأعمال"] // Features in Arabic
        } // Pass features as props
      />
      <PricingCard
        color={"#7731D8"}
        hoverColor={"#612dae"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[2]?.title}` : "غالي"}
        desc={isLang !== "arabic" ? `${packages[2]?.title} Plan` : "الخطة المميزة"}
        price={`${packages[2]?.price}`}
        packageId={"3"}
        duration="month"
        features={
          isLang !== "arabic"
            ? ["Free Templates", "Business Templates", "Premium Templates"]
            : ["قوالب مجانية", "قوالب الأعمال", "قوالب مميزة"] // Features in Arabic
        } // Pass features as props
      />
    </>
  ) : (
    <>
      <PricingCard
        color={"#dedede"}
        hoverColor={"#f4f2f5"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[0]?.title}` : "حر"}
        desc={isLang !== "arabic" ? `${packages[0]?.title} Package` : "حزمة مجانية"}
        price={`${packages[0]?.yprice}`}
        packageId={"1"}
        duration="year"
        features={
          isLang !== "arabic"
            ? ["Free Templates"]
            : ["قوالب مجانية"] // Features in Arabic
        } // Pass features as props
      />
      <PricingCard
        color={"HSLA(0,100%,66%,1)"}
        hoverColor={"#fc4444"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[1]?.title}` : "عمل"}
        desc={isLang !== "arabic" ? `${packages[1]?.title} Plan` : "خطة عمل"}
        price={`${packages[1]?.yprice}`}
        packageId={"2"}
        duration="year"
        features={
          isLang !== "arabic"
            ? ["Free Templates", "Business Templates"]
            : ["قوالب مجانية", "قوالب الأعمال"] // Features in Arabic
        } // Pass features as props
      />
      <PricingCard
        color={"#7731D8"}
        hoverColor={"#612dae"}
        text={"white"}
        title={isLang !== "arabic" ? `${packages[2]?.title}` : "غالي"}
        desc={isLang !== "arabic" ? `${packages[2]?.title} Plan` : "الخطة المميزة"}
        price={`${packages[2]?.yprice}`}
        packageId={"3"}
        duration="year"
        features={
          isLang !== "arabic"
            ? ["Free Templates", "Business Templates", "Premium Templates"]
            : ["قوالب مجانية", "قوالب الأعمال", "قوالب مميزة"] // Features in Arabic
        } // Pass features as props
      />
    </>
  )}
</div>


          {isLang !== "arabic" ? (
            <p className="text-[18px] text-center font-[500] mt-24 mb-16 text-black">
              <span className="text-[#0085FF] ">Our Subscribers</span> can enjoy
              premium Promotional Maker features for free
            </p>
          ) : (
            <p className="text-[18px] text-center font-[500] mt-24 mb-16 text-black">
              <span className="text-[#0085FF] "> يمكن للمشتركين </span> لدينا
              الاستمتاع بميزات صانع العروض الترويجية المتميزة مجانًا
            </p>
          )}
        </section>
        {/* Featucher Cards */}
        <section>
          {isLang !== "arabic" ? (
            <>
              <Feature
                img="/assets/10617254.png"
                bg={"#5198EB22"}
                title1={"Highly Recommended"}
                title={"Make Your Mark Among the Crowd"}
                description={
                  "In a competitive market, the attributes of uniqueness are highly appreciated at Maker4U. Hence, the Promotion Maker tool gives you the freedom to produce attractive promotional materials that will make your audience want to know more."
                }
                description2={
                  "With Maker4U’s Wedding Card designer, you will celebrate your special day with sophistication and elegance."
                }
                description3={
                  "All birthday celebrations are more special with customized birthday cards from the Maker4U. With our Birthday Card maker, you can create unique greetings that express your warm wishes in an unforgettable manner. Select among different humorous templates and personalize them with photos, words and drawings that represent the recipient’s character.  "
                }
              />
              <FeatureTwo
                bg={"#fff"}
                img={ghq4}
                title1={"Best Interface"}
                title={"All in one most sophisticated  designs solutions"}
                description={
                  "Maker4U is a trusted leading platform that perfectly empowers the world to design with an unwavering dedication to excellence. We are passionate about technology and zealots for simple, aesthetically pleasing user interfaces."
                }
                description2={
                  "No matter what you are about to do, either arrange a marriage, announce an event, or celebrate a birthday, our templates set an excellent basis for your tasks. These templates are all clean lines, graceful motifs, and contemporary touches, creating sophistication in everything you do."
                }
                description3={
                  "Our adaptable templates let you create your impression with everything from invitations and flyers to social media posts and business cards. Open up our library today and let you unlock unlimited opportunities for customization with Maker4U’s Sophisticated Templates."
                }
              />
              <Feature
                img={markersection}
                bg={"#1717ff10"}
                title1="Time is money"
                title={"Time Mastery"}
                description={
                  "Uncover the secret of project management effectiveness with Make4U’s Time Mastery. Our easily accessible system will make it simple for you to organize your tasks, set deadlines, and streamline the workflow. "
                }
                description2={
                  "Customizable calendar, interactive to-do list - with our inventive functions you can have a complete control over your time. With real-time updates and synchronized access on all your devices, you remain in control of your projects wherever you are. Procrastination goodbye, productivity hello – thanks to Maker4U’s Time Mastery solutions!"
                }
                description3={""}
              />
              <FeatureTwo
                bg="/assets/image1.png"
                img="/assets/image1.png"
                title1={"Easy to use"}
                title={"Accuracy"}
                description={
                  "With Maker4U’s Accuracy tools, you get to feel precision like never before. With the help of our innovative technology, every project is completed with the highest level of precision, from minute measurements to flawless designs. With our intuitive platform, you will be able to align the elements, modify dimensions, and refine the details flawlessly. "
                }
                description2={
                  "Enhanced with live feedback and superior characteristics, Maker4U will always produce faultless outcomes. Goodbye to errors and welcome to perfection with the Accuracy solutions of Maker4U."
                }
                description3={""}
              />
              <Feature
                img={card7}
                bg={"#1717ff10"}
                title1="Analytics"
                title={"Seamless Analytics Integration"}
                description={
                  "Explore a new concept and make it easy with Maker4U's Seamless Analytics Integration. Learn from the data analytical tools which can help you to improve your performance. Evaluate performance, gauge participation, and make data-informed decisions to increase the effect size. "
                }
                description2={
                  "Build your work seamlessly through analytics platforms for monitoring trends and identifying opportunities directly related to your success. Having access to real-time data at your fingertips gives you the opportunity to keep an eye on the progress and adjust when needed to reach your objectives effectively."
                }
                description3={
                  "The Seamless Analytics Integration is going to be a real game changer for Maker4U which will bring about an evolution in your creative journey."
                }
              />
            </>
          ) : (
            <>
           <FeatureA
  img="/assets/10617254.png"
  bg={"#5198EB22"}
  title1={"موصى به للغاية"}
  title={"اترك بصمتك بين الحشود"}
  description={
    "في سوق تنافسي، تُقدّر خصائص التفرد بشكل كبير في Maker4U. لذلك، يمنحك أداة الترويج الحرية لإنتاج مواد ترويجية جذابة تجعل جمهورك يرغب في معرفة المزيد."
  }
  description2={
    "مع مصمم بطاقات الزفاف من Maker4U، ستحتفل بيومك الخاص بأناقة ورقي."
  }
  description3={
    "جميع الاحتفالات بأعياد الميلاد تكون أكثر خصوصية مع بطاقات عيد الميلاد المخصصة من Maker4U. مع صانع بطاقات عيد الميلاد الخاص بنا، يمكنك إنشاء تهاني فريدة تعبر عن أطيب تمنياتك بطريقة لا تُنسى. اختر من بين قوالب فكاهية مختلفة وخصصها بالصور والكلمات والرسومات التي تمثل شخصية المتلقي."
  }
/>

<FeatureTwoA
  bg={"#fff"}
  img={ghq4}
  title1={"أفضل واجهة"}
  title={"جميع الحلول التصميمية الأكثر تطورًا في مكان واحد"}
  description={
    "Maker4U هو منصة رائدة موثوقة تمكّن العالم من التصميم مع التزام لا يتزعزع بالتميز. نحن شغوفون بالتكنولوجيا ومتحمسون لتجارب المستخدم البسيطة والجمالية."
  }
  description2={
    "سواء كنت تستعد لترتيب زفاف، أو الإعلان عن حدث، أو الاحتفال بعيد ميلاد، فإن قوالبنا توفر أساسًا رائعًا لمهامك. هذه القوالب تتميز بخطوط نظيفة وزخارف رشيقة ولمسات معاصرة، مما يضفي الرقي على كل ما تفعله."
  }
  description3={
    "تتيح لك قوالبنا القابلة للتكيف إنشاء بصمتك الخاصة في كل شيء من الدعوات والنشرات إلى المنشورات على وسائل التواصل الاجتماعي وبطاقات العمل. افتح مكتبتنا اليوم واستمتع بفرص لا حصر لها للتخصيص مع قوالب Maker4U المتطورة."
  }
/>

<FeatureA
  img={markersection}
  bg={"#1717ff10"}
  title1="الوقت هو المال"
  title={"إتقان الوقت"}
  description={
    "اكتشف سر الفعالية في إدارة المشاريع مع إتقان الوقت من Maker4U. سيجعل نظامنا السهل الوصول إليه تنظيم مهامك وتحديد المواعيد النهائية وتبسيط سير العمل أمرًا بسيطًا."
  }
  description2={
    "تقويم قابل للتخصيص، قائمة مهام تفاعلية - مع وظائفنا المبتكرة يمكنك السيطرة الكاملة على وقتك. مع التحديثات الفورية والوصول المتزامن على جميع أجهزتك، تبقى متحكمًا في مشاريعك أينما كنت. وداعًا للتأجيل، مرحبًا بالإنتاجية بفضل حلول إتقان الوقت من Maker4U!"
  }
  description3={""}
/>

<FeatureTwoA
  bg="/assets/image1.png"
  img="/assets/image1.png"
  title1={"سهل الاستخدام"}
  title={"الدقة"}
  description={
    "مع أدوات الدقة من Maker4U، ستشعر بالدقة كما لم تشعر بها من قبل. بفضل تقنيتنا المبتكرة، يتم إكمال كل مشروع بأعلى مستوى من الدقة، من القياسات الدقيقة إلى التصميمات المثالية. مع منصتنا البديهية، ستتمكن من محاذاة العناصر وتعديل الأبعاد وصقل التفاصيل بسهولة."
  }
  description2={
    "معززًا بتغذية راجعة حية وخصائص فائقة، ستنتج Maker4U دائمًا نتائج خالية من الأخطاء. وداعًا للأخطاء ومرحبًا بالكمال مع حلول الدقة من Maker4U."
  }
  description3={""}
/>

<FeatureA
  img={card7}
  bg={"#1717ff10"}
  title1="تحليلات"
  title={"تكامل التحليلات السلس"}
  description={
    "استكشف مفهومًا جديدًا وسهّل العملية مع تكامل التحليلات السلس من Maker4U. تعرّف على أدوات التحليل البياني التي يمكن أن تساعدك في تحسين أدائك. قيّم الأداء، وقس المشاركة، واتخذ قرارات مستندة إلى البيانات لزيادة حجم التأثير."
  }
  description2={
    "قم ببناء عملك بسلاسة من خلال منصات التحليلات لمراقبة الاتجاهات وتحديد الفرص المرتبطة مباشرة بنجاحك. يمنحك الوصول إلى البيانات في الوقت الفعلي فرصة لمراقبة التقدم وضبطه عند الحاجة لتحقيق أهدافك بفعالية."
  }
  description3={
    "تكامل التحليلات السلس سيكون نقطة تحول حقيقية لـ Maker4U، حيث سيحدث ثورة في رحلتك الإبداعية."
  }
/>

            </>
          )}
        </section>
        {/* Unlimited Free Templets */}
        <section
          className="px-4 my-20  text-black"
          style={{
            maxWidth: "1400px",
            margin: "auto",
            marginTop: "40px",
            marginBottom: "40px",
          }}
        >
          <p
            className="text-[28px] sm:text-[28px] md:text-[28px] font-[600] text-center"
            style={{ lineHeight: 1 }}
          >
            {isLang !== "arabic"
              ? "Unlimited Free Templets"
              : "قالب مجاني غير محدود"}
          </p>
          <p
            className="text-center م-auto  mt-4 mb-10 "
            style={{ width: "clamp(300px,100%,1100px)",fontFamily:"poppins", fontSize:"18px" }}
          >
            {" "}
            {isLang !== "arabic"
              ? "Realize boundless creative freedom with Maker4U’s Unlimited Free Templates. See a wide range of styles to be customized for any occasion. The range of our templates is wide starting from business cards and ending with festive invitations. With the whole world open to you turn your dream into reality without any effort and advance your project to the whole new level. Discover unbounded opportunities in Free Templates from Maker4U."
              : "جرّب Promotion Maker for Premium، وهو الحل الشامل للفرق من جميع الأحجام للإنشاء والتعاون معًا."}
          </p>
          <div
            className={`grid  ${
              isDesktop
                ? "grid-cols-6"
                : isTablet
                ? "grid-cols-4"
                : isMobile
                ? "grid-cols-3"
                : "grid-cols-2"
            } gap-4 grid-flow-row auto-rows-[minmax(0,65px)]`}
          >
            <div className=" overflow-hidden row-span-2 h-full">
              <LazyLoadImage
                src={`${resume1}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>
            <div className=" overflow-hidden row-span-4 h-full">
              <LazyLoadImage
                src={`${resume3}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>
            <div className=" overflow-hidden row-span-4 h-full">
              <LazyLoadImage
                src={`${resume3}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>
            <div className=" overflow-hidden row-span-3 h-full">
              <LazyLoadImage
                src={`${resume4}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>
            <div className=" overflow-hidden row-span-3 h-full">
              <LazyLoadImage
                src={`${resume5}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>
            <div className=" overflow-hidden row-span-5 h-full">
              <LazyLoadImage
                src={`${resume6}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>

            <div className=" overflow-hidden row-span-3 h-full">
              <LazyLoadImage
                src={`${resume7}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>
            {/* <div className=" overflow-hidden row-span-3 h-full">
              <LazyLoadImage
                src={`${resume8}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div> */}
            <div className=" overflow-hidden row-span-4 h-full">
              <LazyLoadImage
                src={`${resume9}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>
            <div className=" overflow-hidden row-span-4 h-full">
              <LazyLoadImage
                src={`${resume10}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>
            <div className=" overflow-hidden row-span-4 h-full">
              <LazyLoadImage
                src={`${resume11}`}
                alt="Image"
                
                className="h-full w-full object-cover rounded-md"
              />
            </div>

            {/* <div className=" overflow-hidden row-span-5 h-full">
              <LazyLoadImage
                src={`${resume12}`}
                alt="Image"
                height={200}
                width={200}
                className="h-full w-full object-cover rounded-md"
              />
            </div> */}


            <div className=" overflow-hidden row-span-3 h-full">
              <LazyLoadImage
                src={`${resume13}`}
                alt="Image"
                className="h-full w-full object-cover rounded-md"
              />
            </div>


            <div className=" overflow-hidden row-span-4 h-full">
              <LazyLoadImage
                src={`${resume1}`}
                alt="Image"
                className="h-[200] w-full object-cover rounded-md"
              />
            </div>
            <div className=" overflow-hidden row-span-4 h-full">
              <LazyLoadImage
                src={`${resume14}`}
                alt="Image"
                className="h-[200] w-full object-cover rounded-md "
              />
            </div>
          </div>
        </section>

        <section>
          <Faq />
        </section>

        <Footer />
      </div>
    </div>
  );
};

export default Home;
